import React from "react";
import { useFormContext } from "react-hook-form";

import { AdInfo } from "../../../../assets";
import { EMPTY_STRING } from "../../../../constants";

const AdInformation = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className="create-form-card">
      <div className="form-card-heading">
        <img src={AdInfo} alt={EMPTY_STRING} />
        Ad Information
      </div>
      <input
        type="text"
        className={`create-list-input ${
          errors.title ? "border border-danger" : EMPTY_STRING
        }`}
        placeholder="Enter Property Title e.g. Beautiful House in New York City"
        {...register("title")}
      />
      <textarea
        className={`create-list-input ${
          errors.description ? "border border-danger" : EMPTY_STRING
        }`}
        placeholder="Describe your property, it’s features, area if it is in etc."
        rows={12}
        {...register("description")}
      />
    </div>
  );
};

export default AdInformation;
